function normalizeCompanyDirectoryPreferences(companySlugs, storedPreferences = {}) {
  const knownSlugs = uniqueStrings(companySlugs);
  const known = new Set(knownSlugs);
  const storedOrder = uniqueStrings(storedPreferences && storedPreferences.order)
    .filter((slug) => known.has(slug));
  const order = [...storedOrder, ...knownSlugs.filter((slug) => !storedOrder.includes(slug))];
  const hidden = uniqueStrings(storedPreferences && storedPreferences.hidden)
    .filter((slug) => known.has(slug));

  if (hidden.length === knownSlugs.length && knownSlugs.length > 0) {
    hidden.splice(hidden.indexOf(knownSlugs[0]), 1);
  }

  return { order, hidden };
}

function moveCompanyDirectoryItem(preferences, movedSlug, targetSlug, placeAfter = false) {
  const order = uniqueStrings(preferences && preferences.order);
  if (movedSlug === targetSlug || !order.includes(movedSlug) || !order.includes(targetSlug)) {
    return { ...preferences, order };
  }

  const nextOrder = order.filter((slug) => slug !== movedSlug);
  const targetIndex = nextOrder.indexOf(targetSlug);
  nextOrder.splice(targetIndex + (placeAfter ? 1 : 0), 0, movedSlug);
  return { ...preferences, order: nextOrder };
}

function toggleCompanyDirectoryVisibility(preferences, slug) {
  const order = uniqueStrings(preferences && preferences.order);
  const hidden = uniqueStrings(preferences && preferences.hidden)
    .filter((hiddenSlug) => order.includes(hiddenSlug));

  if (!order.includes(slug)) {
    return { ...preferences, order, hidden };
  }

  if (hidden.includes(slug)) {
    return { ...preferences, order, hidden: hidden.filter((hiddenSlug) => hiddenSlug !== slug) };
  }

  if (order.length - hidden.length <= 1) {
    return { ...preferences, order, hidden };
  }

  return { ...preferences, order, hidden: [...hidden, slug] };
}

function uniqueStrings(values) {
  if (!Array.isArray(values)) return [];
  return [...new Set(values.filter((value) => typeof value === 'string' && value))];
}

module.exports = {
  moveCompanyDirectoryItem,
  normalizeCompanyDirectoryPreferences,
  toggleCompanyDirectoryVisibility
};
